module.exports = __webpack_public_path__ + "img/top03.20085904.png";